import find from 'lodash/fp/find';
import { computed } from '@nuxtjs/composition-api';

export default function useVariantFeatures(productAttributes) {
  const features = [
    {
      name: 'Skærm',
      icon: 'fa-thin fa-mobile-screen'
    },
    {
      name: 'Kamera',
      icon: 'fa-thin fa-camera'
    },
    {
      name: 'Størrelse',
      icon: 'fa-thin fa-ruler'
    }
  ]
  const specList = [
    {
      title: 'Højde',
      attrName: 'Height'
    },
    {
      title: 'Bredde',
      attrName: 'Width'
    },
    {
      title: 'Dybde',
      attrName: 'Depth'
    },
    {
      title: 'Vægt',
      attrName: 'Weight'
    },
    {
      title: 'Skærmstørrelse',
      attrName: 'ScreenSize'
    },
    {
      title: 'Skærmopløsning',
      attrName: 'ScreenResolution'
    },
    {
      title: 'Skærmtype',
      attrName: 'DisplayType'
    },
    {
      title: 'Kameraopløsning',
      attrName: 'CameraResolution'
    },
    {
      title: 'Frontkameraopløsning',
      attrName: 'FrontCameraResolution'
    },
    {
      title: 'Processor',
      attrName: 'Processor'
    },
    {
      title: 'RAM',
      attrName: 'RAM'
    },
    {
      title: 'Batterikapacitet',
      attrName: 'BatteryCapacity'
    },
    {
      title: 'Max ekstern hukommelse',
      attrName: 'MaxExternalMemory'
    },
    {
      title: 'Operativsystem',
      attrName: 'OperatingSystem'
    },
    {
      title: 'Tilslutning oplader',
      attrName: 'CableConnectivity'
    },
    {
      title: 'Tilslutning hovedtelefoner',
      attrName: 'HeadsetConnection'
    },
    {
      title: '5G',
      attrName: '5G'
    },
    {
      title: 'E-SIM',
      attrName: 'E-SIM'
    },
    {
      title: 'Dual SIM',
      attrName: 'DualSIM'
    }
  ]
  const featureList = () => {
    const isValidValue = v => {
      return (v !== null && v !== 0 && !v.includes('null'))
    }
    const featureValues = {
      Skærm: [
        getScreenSize() + getAttributeValueIfPresent('DisplayType'),
        getAttributeValueIfPresent('ScreenResolution')
      ],
      Kamera: [
        getAttributeValueIfPresent('CameraResolution'),
        getFrontCameraResolution()
      ],
      Størrelse: [
        getDimensions(),
        getWeight()
      ]
    }

    Object.keys(featureValues).forEach(val => { // filter out invalid values
      featureValues[val] = featureValues[val].filter(isValidValue)
    })

    const featureListVal = Object.keys(featureValues).map(value => {
      const item = features.find(feature => feature.name === value)
      item.values = featureValues[value]
      return item
    }).filter(item => item.values.length)
    return featureListVal
  }
  const getAttributeValue = (attributeName) => {
    return find({ name: attributeName })(productAttributes)?.value
  }
  const getAttributeValueIfPresent = (attributeName) => {
    return getAttributeValue(attributeName) !== undefined ? getAttributeValue(attributeName) : null
  }
  const getScreenSize = () => {
    return getAttributeValue('ScreenSize') !== undefined ? getAttributeValue('ScreenSize') + "'' " : null
  }
  const getFrontCameraResolution = () => {
    return getAttributeValue('FrontCameraResolution') !== undefined ? 'Front: ' + getAttributeValue('FrontCameraResolution') : null
  }
  const getDimensions = () => {
    const height = getAttributeValue('Height')
    const width = getAttributeValue('Width')
    const depth = getAttributeValueIfPresent('Depth')
    if (height !== undefined && width !== undefined) {
      return height + ' x ' + width + ' x ' + depth
    }
    return null
  }
  const getWeight = () => {
    return getAttributeValue('Weight') !== undefined ? 'Vægt: ' + getAttributeValue('Weight') : null
  }
  const getDanishVal = (val) => {
    return val.toLowerCase() === 'true' ? 'Ja' : 'Nej'
  }
  const isBoolean = (val) => {
    return val.toLowerCase() === 'true' || val.toLowerCase() === 'false'
  }
  const productSpecList = computed(() => {
    const availableSpecList = []
    specList.forEach(spec => {
      const attrVal = getAttributeValue(spec.attrName)
      if (attrVal !== undefined) {
        spec.description = isBoolean(attrVal) ? getDanishVal(attrVal) : attrVal
        availableSpecList.push(spec)
      }
    })
    return availableSpecList
  })
  return {
    productSpecList,
    featureList,
    getAttributeValue,
    getAttributeValueIfPresent,
    getScreenSize,
    getFrontCameraResolution,
    getDimensions,
    getWeight
  }
}
